import React from 'react';
//import { CSSTransition } from 'react-transition-group';

import ConstantObject from '../Components/Constants';

import '../Styles/Social.css'

export default class ImageSizes extends React.Component {

  constructor(props) {
    super(props);
    console.log("imagesizes  ....");
    //debugger;

    this.mountStyle = this.mountStyle.bind(this)
    this.unMountStyle = this.unMountStyle.bind(this)
    this.state ={ //base css
      show: true,
      style :{
        fontSize: 60,
        opacity: 0,
        transition: 'all 2s ease',
      }
    }
  }

  handleClick(p) {
    //e.preventDefault();
//    debugger;
    setTimeout(this.mountStyle, 10) // call the into animation
    setTimeout(this.props.SetImageSize(p), 500)
  }

  componentWillReceiveProps(newProps) { // check for the mounted props
    if(!newProps.mounted)
      return this.unMountStyle() // call outro animation when mounted prop is false
    this.setState({ // remount the node when the mounted prop is true
      show: true
    })
    setTimeout(this.mountStyle, 10) // call the into animation
  }

  unMountStyle() { // css for unmount animation
    this.setState({
      style: {
        fontSize: 60,
        opacity: 0,
        transition: 'all 1s ease',
      }
    })
  }

  mountStyle() { // css for mount animation
    this.setState({
      style: {
        fontSize: 60,
        opacity: 1,
        left: "55px",
        transition: 'left' + ConstantObject.delayLeft + ' ease, opacity ' + ConstantObject.delayLeft + ' ease',
      }
    })
  }

  componentDidMount(){
    setTimeout(this.mountStyle, 10) // call the into animation
  }

  render () {
    return (this.state.show &&
        <div className="scrolling-wrapper-flexbox" style={this.state.style} >
          {this.props.imageListArray.map(item =>
            <button key={item.key} onClick={() => this.handleClick(item)}>
              <img className="cardimgsizes" src={ConstantObject.quotes_img_sizes_root+item.url} alt={item.title} />
            </button>
          )}
        </div>
      )
  }

}
